export const FETCH_BRAND_LOGO = 'fetchBrandLogo';
export const UPDATE_BRAND_LOGO = 'updateLogo';
export const FETCH_TAGS = 'fetchTags';
export const FETCH_CATEGORY_TAGS = 'fetchCategoryTags';
export const FETCH_NON_CATEGORY_TAGS = 'fetchNonCategoryTags';
export const FETCH_PLAN = 'fetchPlan';
export const FETCH_FEATURES = 'fetchFeatures';
export const FETCH_FEATURE_BY_UID = 'fetchFeatureByUid';
export const FETCH_IS_FAVORITE_FEATURE = 'fetchIsFavoriteFeature';
export const ADD_FEATURE_TO_FAVORITES = 'addFeatureToFavorites';
export const REMOVE_FEATURE_FROM_FAVORITES = 'removeFeatureFromFavorites';
export const SEARCH_FEATURES = 'searchFeatures';
export const SEARCH_FEATURES_BY_TAG = 'searchFeaturesByTag';
export const CLEAR_SEARCH_FEATURES_RESULT = 'clearSearchFeaturesResult';
export const AUTOCOMPLETE_SEARCH = 'autocompleteSearch';
export const CLEAR_AUTOCOMPLETE_RESULT = 'clearAutocompleteResult';
export const FETCH_RECENTLY_SEARCHED = 'fetchRecentlySearched';
export const ADD_RECENTLY_SEARCHED = 'addRecentlySearched';
export const CLEAR_RECENTLY_SEARCHED = 'clearRecentlySearched';
export const UPDATE_FEATURE_SETTINGS = 'updateFeatureSettings';
export const ENABLE_FEATURE = 'enableFeature';
export const DISABLE_FEATURE = 'disableFeature';
export const CLEAR_FEATURE_ACTION_ERROR = 'clearFeatureActionError';
export const UPDATE_DISABLE_TYPING_EFFECT = 'updateDisableTypingEffect';

export default {};
